module.exports = __webpack_public_path__ + "assets/img/02b.6eb319fc.jpg";